import { PropsWithChildren, ReactElement } from "react";
import styles from "./FrequentlyAskedQuestionsItemLayout.module.less";
import {
	isNil,
	isNotNil,
	setTrackingId
} from "client/Misc/utils";
import { HeightAnimationContainer, Icon } from "client/Components";
import classNames from "classnames";
import { useCallbackWithoutArguments } from "client/Hooks";

export type FrequentlyAskedQuestionsItemLayoutProps = {
	trackingId: string;
};

export const FrequentlyAskedQuestionsItemLayout = (props: PropsWithChildren<FrequentlyAskedQuestionsItemLayoutProps>): ReactElement => {
	const {
		children,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{children}
		</div>
	);
};
FrequentlyAskedQuestionsItemLayout.displayName = "FrequentlyAskedQuestionsItemLayout";

type FrequentlyAskedQuestionsItemLayoutQuestionProps = {
	trackingId: string;
} & ({
	onClick: () => void;
	isExpanded: boolean;
} | {
	onClick?: undefined;
	isExpanded?: undefined;
});

const FrequentlyAskedQuestionsItemLayoutQuestion = (props: PropsWithChildren<FrequentlyAskedQuestionsItemLayoutQuestionProps>): ReactElement => {
	const {
		onClick: onClickFromProps,
		isExpanded,
		children,
		trackingId
	} = props;

	const onClick: (() => void) | undefined = useCallbackWithoutArguments(onClickFromProps);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.question,
				{
					[styles.question_isExpandable]: isNotNil(onClick)
				}
			)}
			onClick={onClick}
		>
			<span className={styles.title}>
				{children}
			</span>
			<span className={styles.icon}>
				<Icon
					value={isNil(isExpanded) || isExpanded
						? "chevron-up"
						: "chevron-down"
					}
				/>
			</span>
		</div>
	);
};
FrequentlyAskedQuestionsItemLayoutQuestion.displayName = "FrequentlyAskedQuestionsItemLayout.Question";

type FrequentlyAskedQuestionsItemLayoutAnswerProps = {
	trackingId: string;
	isExpanded: boolean;
};

const FrequentlyAskedQuestionsItemLayoutAnswer = (props: PropsWithChildren<FrequentlyAskedQuestionsItemLayoutAnswerProps>): ReactElement => {
	const {
		trackingId,
		isExpanded,
		children
	} = props;

	return (
		<HeightAnimationContainer
			isVisible={isExpanded}
		>
			<div
				{...setTrackingId(trackingId)}
				className={styles.answer}
			>
				{children}
			</div>
		</HeightAnimationContainer>
	);
};
FrequentlyAskedQuestionsItemLayoutAnswer.displayName = "FrequentlyAskedQuestionsItemLayout.Answer";

FrequentlyAskedQuestionsItemLayout.Question = FrequentlyAskedQuestionsItemLayoutQuestion;
FrequentlyAskedQuestionsItemLayout.Answer = FrequentlyAskedQuestionsItemLayoutAnswer;

